import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Loader from '../../../components/common/Loader';
import { GLOBAL_DEFAULT } from '../../../constants/global';
import { pollBulkShippingJob } from '../../../helpers/utils';
import { orderService } from '../services';

const PrintReturnLabel: React.FC<any> = () => {
    const [state, setState] = useState<any>(null);
    const [orderDetail, setOrderDetail] = useState<any>();
    const [loading, setLoading] = useState<boolean>(GLOBAL_DEFAULT.LOADER_STATE);
    const [progressText, setProgressText] = useState<string>('');

    useEffect(() => {
        try {
            const windowName = window?.name;
            const state = JSON.parse(windowName);

            setState(state);
        } catch (error) {
            console.error('Failed to parse state from window name', error);
            window.location.href = '/app/dashboard';
        }
    }, []);

    const getOrderDetail = useCallback(async () => {
        if (state?.orderId) {
            setLoading(true);
            setProgressText('');
            try {
                const payload = {
                    orderIds: state?.orderId,
                    type: state?.orderType || 'Orders'
                }

                // Enqueue as a background job instead of blocking this window on a ShipEngine
                // return-label call per order — poll for progress/completion instead.
                const enqueueResponse = await orderService.enqueueReturnLabel(payload);
                const jobId = enqueueResponse?.data?.job_id;

                const jobStatus = await pollBulkShippingJob(jobId, orderService.getBulkShippingJobStatus, {
                    onProgress: (status) => {
                        const progress = status?.progress as any;
                        if (progress?.total) {
                            setProgressText(`Creating return label(s)… ${progress.completed}/${progress.total}`);
                        }
                    }
                });

                const orderDetail = jobStatus?.result?.successOrders?.map((order: any) => {
                    return {
                        ...order,
                        is_return_label: order?.returnShipping?.packages?.some((packageItem: any) => packageItem?.label_download?.png)
                    }
                });

                setOrderDetail(orderDetail);
            } catch (error) {
                console.error(":: Order Management :: Return Label printing error - ", error);
            } finally {
                setLoading(false);
                setProgressText('');
            }
        }

    }, [state?.orderId, state?.orderType]);

    useEffect(() => {
        getOrderDetail();

    }, [getOrderDetail]);

    return <>
        <Loader isLoading={loading} />
        {loading && progressText && (
            <div className="text-center hide-on-print py-2 small text-muted">{progressText}</div>
        )}
        <div className='text-center hide-on-print py-3'><Button className='custom-min-width-85' size='sm' variant="dark" onClick={() => window.print()}>Print</Button></div>
        {orderDetail?.map((orderDetails: any, index: any) => (

            <div key={index} style={{ pageBreakBefore: 'always', lineHeight: 1.2 }}>
                {orderDetails?.is_return_label ?
                    <>
                        {orderDetails?.returnShipping?.packages?.map((package_label: any, packageLabelIndex: any) => {
                            return <div key={packageLabelIndex} style={{ textAlign: 'center', pageBreakInside: "avoid" }}>
                                <img
                                    src={package_label?.label_download?.png}
                                    alt="Return Label"
                                    width={576}
                                    height={1020}
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '100vh',
                                        height: 'auto',
                                        pageBreakInside: "avoid",
                                        objectFit: 'contain'
                                    }}
                                />
                            </div>;
                        })}
                    </> :
                    <>
                        <div style={{ textAlign: 'center', pageBreakInside: "avoid" }}>
                            <img
                                src={orderDetails?.returnShipping?.label_download?.png}
                                alt="Return Label"
                                width={576}
                                height={1020}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100vh',
                                    height: 'auto',
                                    pageBreakInside: "avoid",
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                    </>
                }
            </div>
        ))}
    </>;
}

export default PrintReturnLabel;